window.chartFestgeld = {
	data: {
		// Liqui
		bruttowerte: [],
		einnahmen: [],
		ausgaben: [],
		zulagen: [],
		kosten: [],
		// Steuer
		zvks: [],
		steuer: [],
		// Sonstiges
		bewertungsdatum: 0,
		startdatum: 0,
		enddatum: 0,
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_festgeld", {
			chart: {
				chartType: "liqui", // ["liqui", "steuer"]
				events: {
					selection: function (event) {
						return zoomIn(chartFestgeld, event)
					},
				},
			},

			legend: {
				enabled: true,
			},

			yAxis: [
				{},
				{
					opposite: true,
				},
			],

			xAxis: {
				ordinal: false,
				min: this.data.startdatum,
				max: this.data.enddatum,
				anzeigeformat: "jahr",
				plotLines: [
					{
						id: "bewertungsplotline",
						color: "#2F3435",
						width: 2,
						dashStyle: "longdashdot",
						zIndex: 10,
						bewertungsdatum: this.data.bewertungsdatum,
						value: this.data.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000, // Das Chart öffnet immer in der Jahresansicht
						label: {
							text: `Aktuelle Bewertung<br>zum ${moment(new Date(this.data.bewertungsdatum)).format("MM/YYYY")}`,
							rotation: 0,
							y: 15,
							x: 10,
							textAlign: "left",
							style: {
								color: chartFontColorGrau,
								fontSize: "14px",
							},
						},
					},
				],
				events: {
					afterSetExtremes: function (event) {
						const chart = event.target.chart,
							min = event.min,
							max = event.max

						updateDataGrouping(chart, min, max)
						updateBewertungPlotline(chart)
					},
				},
			},
			series: this.seriesLiqui(),
		})

		// Wenn der Chart Zeitraum kleiner ist als die Monatsgrenze das DataGrouping deaktivieren
		updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesLiqui(), this.seriesSteuer()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		// xAchse: Min und Max aktualisieren
		this.updateXAxisMinMax()

		// Bewertungsline aktualisieren
		this.updateBewertungLinie()

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	updateXAxisMinMax() {
		const seriesMaxValues = this.chart.series.map((serie) => (Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined)),
			xAxisMaxValue = Math.max(this.data.enddatum, ...seriesMaxValues.filter((element) => element !== undefined))
		this.chart.xAxis[0].update({ min: this.data.startdatum, max: xAxisMaxValue })
	},

	updateBewertungLinie() {
		const plotLineOptions = this.chart.xAxis[0].options.plotLines[0]
		plotLineOptions.bewertungsdatum = this.data.bewertungsdatum
		plotLineOptions.value = this.data.bewertungsdatum
		plotLineOptions.label.text = `Aktuelle Bewertung<br>zum ${moment(new Date(this.data.bewertungsdatum)).format("MM / YYYY")}`

		if (this.chart.options.plotOptions.series.dataGrouping.enabled) {
			plotLineOptions.value = plotLineOptions.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000
		}

		this.chart.xAxis[0].options.plotLines[0] = Object.assign({}, this.chart.xAxis[0].options.plotLines[0], plotLineOptions)
	},

	updateSeriesData(seriesData, chartType) {
		// Alle Series entfernen
		while (this.chart.series.length > 0) {
			this.chart.series[0].remove(false)
		}

		// Series hinzufügen
		seriesData.forEach((serie) => {
			this.chart.addSeries(serie, false)
		})

		// XAchse Max Data prüfen und ggf. aktualisieren
		this.updateXAxisMinMax()

		// ChartType setzuen damit in der Detailansicht unterschieden werden kann ob liqui oder steuer
		this.chart.options.chart.chartType = chartType
		this.chart.redraw({ duration: chartAnimationDuration })
	},

	seriesLiqui() {
		return [
			{
				name: "Anlagewert",
				id: "anlagewert",
				legendName: "Anlagewert",
				yAxis: 0,
				type: "area",
				color: farbeNettovermoegen,
				zIndex: 0,
				data: this.data.bruttowerte,
			},
			{
				name: "Zulagen",
				id: "zulagen",
				legendName: "Zulagen",
				yAxis: 1,
				type: "column",
				color: farbeZulagen,
				zIndex: 1,
				stack: "ein_ausgaben",
				data: this.data.zulagen,
			},
			{
				name: "Einzahlungen",
				id: "einnahmen",
				legendName: "Einzahlungen",
				yAxis: 1,
				type: "column",
				color: farbeEinnahmen,
				zIndex: 1,
				stack: "ein_ausgaben",
				data: this.data.einnahmen,
			},
			{
				name: "Auszahlungen",
				id: "ausgaben",
				legendName: "Auszahlungen",
				yAxis: 1,
				type: "column",
				color: farbeAusgaben,
				zIndex: 1,
				stack: "ein_ausgaben",
				data: this.data.ausgaben,
			},
			{
				name: "Kosten",
				id: "kosten",
				legendName: "Kosten",
				yAxis: 1,
				type: "column",
				color: farbeKosten,
				zIndex: 1,
				stack: "ein_ausgaben",
				data: this.data.kosten,
			},
		]
	},

	seriesSteuer() {
		return [
			{
				name: "steuerpflichtiger Kapitalertrag",
				id: "zvk",
				legendName: "steuerpflichtiger Kapitalertrag",
				type: "column",
				color: farbeZuVersteuerndesEinkommen,
				stacking: false,
				grouping: false,
				data: this.data.zvks,
			},
			{
				name: "Kapitalertragsteuer",
				id: "steuer",
				legendName: "Kapitalertragsteuer",
				type: "column",
				color: farbeSteuerBetrag,
				stacking: false,
				grouping: false,
				data: this.data.steuer,
			},
		]
	},
}
